






























































import LayoutReport from "@/layouts/LayoutReport.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { ManagerFleetModule } from "@/store/modules/fleet/manager-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";
import { PartnerColor } from "@/lib/partnerColor";
import ErrorCard from "@/components/utility/ErrorCard.vue";

@Component({
  components: {
    LayoutReport,
    ErrorCard
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class FleetHomeView extends Vue {
  loading = false;
  isError = false;

  fleetId: string | null = null;

  get partnerId() {
    return ReportModule.partner.id;
  }

  get fleetIds() {
    return new Set(UserModule.fleetPermission?.map(p => p.fleetId)).values();
  }

  get fleetIdList() {
    return Array.from(new Set(UserModule.fleetPermission?.map(p => p.fleetId)).values());
  }

  get partnerColor() {
    return new PartnerColor();
  }

  get fleet() {
    return ManagerFleetModule.current;
  }

  get title() {
    return `${this.$t("report.thgOverview.title")}  ${UserModule.user.firstName} ${UserModule.user.lastName} ☀️`;
  }

  get description() {
    return this.$t("report.thgOverview.description");
  }

  get navItems() {
    return [
      {
        title: "report.thgVehicleOverview.title",
        isEnabled: true,
        items: [
          {
            title: "report.thgOverview.vehicle.overview",
            click: () => this.$router.push({ name: "FleetVehicleView" }),
            src: "https://static.mmmint.ai/wirkaufendeinethg/parkplatz-1.jpeg",
            isEnabled: true
          }
        ].filter(x => x.isEnabled)
      },
      {
        title: "navigation.ThePartnerList.report",
        isEnabled: true,
        items: [
          {
            title: "navigation.ThePartnerList.report",
            click: () => this.$router.push({ name: "FleetDamageView" }),
            src: "https://static.mmmint.ai/app/contact/kontaktformular.jpeg",
            isEnabled: true
          }
        ].filter(x => x.isEnabled)
      },
      {
        title: "report.thgOverview.other",
        isEnabled: true,
        items: [
          {
            title: "report.thgOverview.billing",
            click: () => this.$router.push({ name: "FleetInvoiceView" }),
            src: "https://static.mmmint.ai/wirkaufendeinethg/thg-overview-contact-cash-1.jpeg",
            isEnabled: true
          },
          {
            title: "common.nouns.analytics",
            click: () => this.$router.push({ name: "FleetAnalyticsView" }),
            src: "https://static.mmmint.ai/wirkaufendeinethg/insurance-check-1.jpeg",
            isEnabled: true
          }
        ].filter(x => x.isEnabled)
      }
    ].filter(x => x.isEnabled);
  }

  async mounted() {
    const fleetId = this.fleetIds.next().value;

    if (!fleetId) {
      this.isError = true;
      return;
    }

    this.fleetId = fleetId;
    await this.load();
  }

  async load() {
    if (!this.fleetId) {
      return;
    }

    this.loading = true;

    try {
      await ManagerFleetModule.getOne({ partnerId: this.partnerId, fleetId: this.fleetId });
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }
}
